import React from 'react';
import { IconProps } from '../types';
const MinecraftBamboo: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="12" y="1" width="1" height="1" fill="rgba(86, 129, 18, 255)" />
<rect x="13" y="1" width="1" height="1" fill="rgba(86, 129, 18, 255)" />
<rect x="14" y="1" width="1" height="1" fill="rgba(80, 117, 22, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(86, 129, 18, 255)" />
<rect x="12" y="2" width="1" height="1" fill="rgba(94, 138, 36, 255)" />
<rect x="13" y="2" width="1" height="1" fill="rgba(80, 117, 22, 255)" />
<rect x="14" y="2" width="1" height="1" fill="rgba(69, 99, 23, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(86, 129, 18, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(94, 138, 36, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(80, 117, 22, 255)" />
<rect x="13" y="3" width="1" height="1" fill="rgba(69, 99, 23, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(138, 174, 96, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(94, 138, 36, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(80, 117, 22, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(69, 99, 23, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(86, 129, 18, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(94, 138, 36, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(151, 196, 99, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(69, 99, 23, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(86, 129, 18, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(80, 117, 22, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(80, 117, 22, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(61, 90, 31, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(80, 117, 22, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(120, 160, 48, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(105, 144, 34, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(80, 117, 22, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(94, 138, 36, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(80, 117, 22, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(69, 99, 23, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(94, 138, 36, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(148, 187, 79, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(80, 117, 22, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(94, 138, 36, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(80, 117, 22, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(69, 99, 23, 255)" />
<rect x="13" y="8" width="1" height="1" fill="rgba(105, 144, 34, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(138, 174, 96, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(94, 138, 36, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(80, 117, 22, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(69, 99, 23, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(80, 117, 22, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(94, 138, 36, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(151, 196, 99, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(69, 99, 23, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(80, 117, 22, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(80, 117, 22, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(80, 117, 22, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(69, 99, 23, 255)" />
<rect x="1" y="12" width="1" height="1" fill="rgba(80, 117, 22, 255)" />
<rect x="2" y="12" width="1" height="1" fill="rgba(94, 138, 36, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(80, 117, 22, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(61, 90, 31, 255)" />
<rect x="1" y="13" width="1" height="1" fill="rgba(61, 90, 31, 255)" />
<rect x="2" y="13" width="1" height="1" fill="rgba(80, 117, 22, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(61, 90, 31, 255)" />
<rect x="1" y="14" width="1" height="1" fill="rgba(61, 90, 31, 255)" />
<rect x="2" y="14" width="1" height="1" fill="rgba(61, 90, 31, 255)" />
</svg>);
export default MinecraftBamboo;